import { render, staticRenderFns } from "./TopClients.vue?vue&type=template&id=57aa9ea0&scoped=true"
import script from "./TopClients.vue?vue&type=script&lang=js"
export * from "./TopClients.vue?vue&type=script&lang=js"
import style0 from "./TopClients.vue?vue&type=style&index=0&id=57aa9ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa9ea0",
  null
  
)

export default component.exports